import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const Prospects = lazy(() => import("./Prospects").then((module) => ({ default: module.Prospects })));

export const ProspectsAsync = () => {
  return (
    <Suspense fallback={<LoadingIndicatorFullPage open />}>
      <Prospects />
    </Suspense>
  );
};
